import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Stack, Avatar } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import SchoolIcon from '@mui/icons-material/School';
import dayjs from "dayjs";
// import ReportsTrendWeb from "./ReportsTrendWeb";
import BadgeIcon from "@mui/icons-material/EmojiEvents";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo.png";


const reportTypeMap = {
    monthly: { label: "miesięczny", icon: <CalendarMonthIcon fontSize="large" /> },
    quarter: { label: "kwartalny", icon: <CalendarTodayIcon fontSize="large" /> },
    vr: { label: "za VR", icon: <SportsEsportsIcon fontSize="large" /> },
    training: { label: "za szkolenie", icon: <SchoolIcon fontSize="large" /> },
};

const lightenHex = (hex, amount = 0.2) => {
    if (!hex) return hex;
    hex = hex.replace("#", "");
    if (hex.length === 8) hex = hex.substring(0, 6);
    const num = parseInt(hex, 16);
    let r = Math.min(255, ((num >> 16) + 255 * amount) | 0);
    let g = Math.min(255, (((num >> 8) & 0xff) + 255 * amount) | 0);
    let b = Math.min(255, ((num & 0xff) + 255 * amount) | 0);
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
};

export default function UserStatsCardWeb({ report, reports }) {
    const [engagementChange, setEngagementChange] = useState(null);

    const navigate = useNavigate()

    const reportBgColor = {
        monthly: "#1e6169",
        quarter: "#2d376d",
        vr: "#471047",
        training: "#43127bff",
    }[report?.type];

    const sortedReports = Array.isArray(reports)
        ? [...reports].filter(r => r?.createdAt).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        : [];

    const currentIndex = sortedReports.findIndex(r => r.id === report.id);
    const lastReports = currentIndex !== -1 ? sortedReports.slice(currentIndex + 1, currentIndex + 4) : [];

    const calculateReportTotal = rep => {
        if (!rep?.vrData) return 0;
        return rep.vrData.reduce((sum, data) => {
            const poziomyValues = Object.values(data?.poziomy ?? {});
            const total = poziomyValues.reduce(
                (acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0),
                0
            );
            return sum + total;
        }, 0);
    };

    useEffect(() => {
        if (!report || !lastReports?.length) return;
        const currentTotal = calculateReportTotal(report);
        const previousTotal = calculateReportTotal(lastReports[0]);
        if (previousTotal > 0) {
            const change = ((currentTotal - previousTotal) / previousTotal) * 100;
            setEngagementChange(change);
        } else setEngagementChange(0);
    }, [report, lastReports]);

    return (
        <Card sx={{ backgroundColor: reportBgColor, borderRadius: 3, mb: 0, position: "relative", color: "#fff" }}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography variant="subtitle1">{dayjs(report?.createdAt).format("YYYY-MM-DD HH:mm")}</Typography>
                    {engagementChange !== null && (
                        <Typography variant="body2" sx={{ color: engagementChange >= 0 ? "#4CAF50" : "#d9534f" }}>
                            {engagementChange >= 0 ? "↑" : "↓"} {Math.abs(engagementChange).toFixed(1)}% od ostatniego raportu
                        </Typography>
                    )}
                </Box>

                <Box display="flex" alignItems="center">
                    <Box width={180} height={90}>
                        {/* <ReportsTrendWeb report={report} lastReports={lastReports} /> */}
                        <img
                            src={Logo}
                            alt="Logo"
                            // style={{ maxWidth: "40px", marginRight: "30px" }}
                            style={{ maxWidth: "160px", marginRight: "10px" }}
                        />
                    </Box>
                    <Box ml={4} flex={1}>
                        <Typography variant="body1">Raport nr {report?.id}</Typography>
                        <Typography variant="body2">{report?.reportType}</Typography>
                        <Stack direction="row" spacing={1} mt={1}>
                            <BadgeWeb color="#D4AF37" value={report?.reportData?.earnedCredsGold ?? 0} />
                            <BadgeWeb color="#C0C0C0" value={report?.reportData?.earnedCredsSilver ?? 0} />
                            <BadgeWeb color="#CD7F32" value={report?.reportData?.earnedCredsBronze ?? 0} />
                        </Stack>
                    </Box>
                </Box>

                <Box mt={2} textAlign="right">
                    <Typography
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => navigate(`/report/${report.id}`)}
                    >
                        Zobacz szczegóły →
                    </Typography>
                </Box>

                <Typography sx={{ position: "absolute", right: 16, top: 36, color: lightenHex(reportBgColor, 0.4) }}>
                    {reportTypeMap[report?.type]?.label}
                </Typography>
                <Box sx={{ position: "absolute", right: 16, bottom: 48 }}>{reportTypeMap[report?.type]?.icon}</Box>
            </CardContent>
        </Card>
    );
}

function BadgeWeb({ color, value }) {
    return (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ bgcolor: "#365b77", px: 1, py: 0.5, borderRadius: 1 }}>
            <BadgeIcon sx={{ color, fontSize: 18 }} />
            <Typography sx={{ color, fontWeight: 600 }}>{value}</Typography>
        </Stack>
    );
}
